'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _wrapper = require('./wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _content = require('./content');

var _content2 = _interopRequireDefault(_content);

var _closeButton = require('./close-button');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _dialog = require('./dialog');

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: Volume for videos needs to be tied to global volume variable


/** @class Overlay
 * Displays a piece of content in a modal overlay and
 * adds overlay functionality to the global vexpo object.
 */
var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  /** @constructor
    * Constructs a new overlay.
    */
  function Overlay(props) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));

    _this.state = { visible: false };
    _this.exit = _this.exit.bind(_this);
    _this.showContent = _this.showContent.bind(_this);
    _this.prepContent = _this.prepContent.bind(_this);
    return _this;
  }
  /** @method exit
    * Exits the currently displayed overlay
    */


  _createClass(Overlay, [{
    key: 'exit',
    value: function exit() {
      this.setState({
        content: undefined,
        visible: false
      }, function () {
        if (window.vexpo && window.vexpo.sound) window.vexpo.sound.unshush();
      });
    }
    /** @method prepContent
      * Instaciates the appropriate Component for the
      * supplied content.
      * @param {Object} content - an object defining the content
      */

  }, {
    key: 'prepContent',
    value: function prepContent(content) {
      switch (content.type) {
        case 'article':
          return _react2.default.createElement('article', { dangerouslySetInnerHTML: { __html: content.html } });
        case 'image':
          return _react2.default.createElement(
            'figure',
            null,
            _react2.default.createElement('img', { src: content.image, alt: content.alt }),
            _react2.default.createElement('figcaption', { dangerouslySetInnerHTML: { __html: content.caption } })
          );
        case 'audio':
          return _react2.default.createElement('audio', { src: content.audio, autoplay: true, controls: true, volume: volume });
        case 'video':
          return _react2.default.createElement(_reactPlayer2.default, { url: content.video, playing: true, controls: true });
        default:
          return '';
      }
    }
    /** @method showContent
      * Shows the provided content in the overlay.
      * @param {Object} content - an object defining the content
      */

  }, {
    key: 'showContent',
    value: function showContent(content) {
      this.setState({
        visible: true,
        content: this.prepContent(content)
      }, function () {
        if (window.vexpo && window.vexpo.sound) window.vexpo.sound.shush();
      });
    }
    /** @method componentDidMount
      * Adds the overlay functionality to the global
      * vexpo object and listen for navigation events
      * (For which we hide)
      */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      window.vexpo.overlay = this.showContent;
      if (window.vexpo.history) {
        this.unlisten = window.vexpo.history.listen(function (location, action) {
          _this2.setState({ visible: false });
        });
      }
    }
    /** @method componentWillUnmount
      * Stops listening for navigation events
      */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unlisten) this.unlisten();
    }
    /** @method render
      * Renders the overlay.
      */

  }, {
    key: 'render',
    value: function render() {
      var visibleClass = this.state.visible ? 'active' : '';
      return _react2.default.createElement(
        _wrapper2.default,
        { className: visibleClass },
        _react2.default.createElement(
          _dialog2.default,
          null,
          _react2.default.createElement(
            _closeButton2.default,
            { onClick: this.exit },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times-circle' })
          ),
          _react2.default.createElement(
            _content2.default,
            null,
            this.state.content
          )
        )
      );
    }
  }]);

  return Overlay;
}(_react.Component);

exports.default = Overlay;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/overlay/overlay.js
// module id = 256
// module chunks = 0